import { getSchema } from '@/core/api'

export default {
  namespaced: true,
  state: {
    schemaConfig: sessionStorage.getItem('schemaConfig')
      ? JSON.parse(sessionStorage.getItem('schemaConfig'))
      : false
  },
  mutations: {
    schemaConfig(state, schemaConfig) {
      state.schemaConfig = schemaConfig
    },
    fetch(state, schemaConfig) {
      state.schemaConfig = schemaConfig
      sessionStorage.setItem('schemaConfig', JSON.stringify(schemaConfig))
    },
    reset(state) {
      state.schemaConfig = false
      sessionStorage.removeItem('schemaConfig')
    }
  },
  actions: {
    schemaConfig({ commit }, schemaConfig) {
      commit('schemaConfig', schemaConfig)
    },
    async fetch({ commit, state }) {
      if (state.schemaConfig === false) {
        const res = await getSchema('config') // 【config】为获取瓷器查询条件数据字典
        commit('fetch', res.data)
      }
    },
    reset({ commit, state }) {
      commit('reset', state)
    }
  },
  getters: {
    schemaConfig: state => {
      return state.schemaConfig
    }
  }
}
